import React, {useState} from "react";
import Burger from '../Hamburger.js'
import MobileNavBar from '../MobileNavBar.js'
import '../Desktop.css'

import Book from '../../Images/Design/PenguinBooks/VeryDangerousThings.jpg'



function VeryDangerousThings(){
	const [open, setOpen] = useState(false);

	return(
		<div class="page">
		    <div class="designContentPageBook">
		    	<div className="mobileNav">
					<Burger open={open} setOpen={setOpen}/>
					<MobileNavBar open={open} setOpen={setOpen}/>
				</div>
		        <div class="contentHMH">
		            <img class="contentImage" src={Book} />
		            <p class="contentTextHMHTitle">Very Dangerous Things</p>
		            <p class="contentTextHMH">Penguin Young Readers</p>
		            <p class="contentTextHMH ItalicText" >Art direction, title lettering, design</p>
		            <br />
		            <p class="contentTextHMH2 ItalicText" >Illustration by Maria Fedoseeva</p>
		        </div>
		    </div>
		</div>
	)
}

export default VeryDangerousThings